import autoComplete from "@tarekraafat/autocomplete.js/dist/autoComplete";
import * as bootstrap from 'bootstrap';
import api from "./ajax";

import getInputSelection from "../utils/getInputSelection";

const sendTo = [];

const addSendTo = (subcontractor) => {
	sendTo.push(subcontractor);
}

const removeSendTo = (key, value) => {
	const index = sendTo.findIndex((element) => {
		return element[key] === value;
	})
	sendTo.splice(index, 1);
}

const sendMessageToAutoComplete = () => {
	if (document.getElementById('sendMessageToAutoComplete')) {
		const sendToAutoComplete = new autoComplete({
			selector: "#sendMessageToAutoComplete",
			placeHolder: "Search sub contractors",
			resultsList: {
				maxResults: 200,
				noResults: true,
			},
			data: {
				src: async (query) => {
					const response = await api.getStaffByName(query);

					if (!response.error) {
						const {body: staff} = response;

						return staff
					}

					return [];
				},
				keys: ['full_name']
			},
			query: (input) => {
				// Split query into array
				const querySplit = input.split(",");
				// Get last query value index
				const lastQuery = querySplit.length - 1;
				// Trim new query
				const newQuery = querySplit[lastQuery].trim();

				return newQuery;
			},
			trigger: () => {
				return true
			},
			events: {
				input: {
					selection(event) {
						const feedback = event.detail;
						const input = sendToAutoComplete.input;
						const {selection: selectionObject} = feedback;

						// Trim selected Value
						const selection = selectionObject.value[selectionObject.key].trim();
						// Split query into array and trim each value
						const query = input.value.split(",").map(item => item.trim());

						// Add the id to send Message to
						addSendTo(selectionObject.value);

						// Remove last query
						query.pop();
						// Add selected value
						query.push(selection);
						// Replace Input value with the new query
						input.value = query.join(", ") + ", ";
					},
					focus: () => {
						sendToAutoComplete.start();
					}
				}
			},
		});

		// On delete
		$('#sendMessageToAutoComplete').on('keydown', (e) => {
			const {keyCode, currentTarget} = e;

			if (keyCode === 8 || keyCode === 46) {
				e.preventDefault();

				const keyPressPos = getInputSelection(currentTarget);
				const {start} = keyPressPos;


				// Split query into array and trim each value
				const query = currentTarget.value.replace(/,\s*$/, "").split(",").map(item => item.trim());
				let inputLength = 0;
				let indexToRemove = false;

				for (let i = 0; i < query.length; i++) {
					const stringLength = query[i].length + 2;

					inputLength += stringLength;

					if (start <= inputLength) {
						indexToRemove = i;
						break;
					}
				}

				if (indexToRemove !== false) {
					const removed = query[indexToRemove];

					query.splice(indexToRemove, 1);

					removeSendTo('detailed_name', removed);
				}

				const newVal = query.length > 0 ? query.join(", ") + ", " : query.join(", ");

				// Replace Input value with the new query
				currentTarget.value = newVal;
			}
		});
	}
};

document.addEventListener('DOMContentLoaded', function () {
	if (!document.getElementById('sendMessageToAutoComplete')) {
		return;
	}

	sendMessageToAutoComplete();

	// On sendTextMessage button click
	const sendTextMessage = document.getElementById('sendTextMessage');
	const modal = document.getElementById('sendMessageModal');

	// Add event listener to the modal to clear the textarea and input on close
	modal.addEventListener('hide.bs.modal', (event) => {
		const {currentTarget} = event;
		const textarea = $(currentTarget).find('textarea');
		const input = $(currentTarget).find('input');

		textarea.val('');
		input.val('');
	});

	if (sendTextMessage) {
		sendTextMessage.addEventListener('click', async () => {
			const message = $('#textMessageBody').val();
			const spinner = sendTextMessage.querySelector('svg');
			if (spinner) spinner.style.display = 'inline-block';

			api.sendTextMessage(sendTo, message)
				.then(response => {
					if (response.error) {
						// Show alert in modal if an error occurred
						const alertDiv = document.createElement('div');
						alertDiv.className = 'alert alert-danger';
						alertDiv.textContent = 'An error occurred while trying to send message';
						// Insert alert at the top of the modal body
						const modalBody = modal.querySelector('.modal__body');
						modalBody.insertBefore(alertDiv, modalBody.firstChild);
					} else {
						// If successful, hide spinner and close the modal
						if (spinner) spinner.style.display = 'none';
						const modalInstance = bootstrap.Modal.getInstance(modal);
						if (modalInstance) modalInstance.hide();
					}
				})
				.catch(() => {
					const alertDiv = document.createElement('div');
					alertDiv.className = 'alert alert-danger';
					alertDiv.textContent = 'An error occurred while trying to send message';
					const modalBody = modal.querySelector('.modal__body');
					modalBody.insertBefore(alertDiv, modalBody.firstChild);
				})
				.finally(() => {
					if (spinner) spinner.style.display = 'none';
				});

			// Close the sendMessageModal modal

			// const modalInstance = bootstrap.Modal.getInstance(modal);
			// if (modalInstance) {
			// 	modalInstance.hide();
			// }

		});
	}
});
